import React from 'react';

// Models
import { Phone } from 'Modules/Models/Phone';
import { User } from 'Modules/Models/User';

// Rechart
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Cell,
    Text,
    LabelList,
} from 'recharts';

type PhoneHorizontalBarGraphProps = {
    users: User[];
    phones: Phone[];
};
function PhoneHorizontalBarGraph({
    phones,
    users,
}: PhoneHorizontalBarGraphProps) {
    let data = users.map((user, i) => ({
        category: user.username,
        Phones: phones.filter((p) => p.userId === user.id).length,
    }));
    data.push({
        category: 'Unassigned',
        Phones: phones.filter((p) => p.userId == null).length,
    });
    const CustomYAxisTick = ({ x, y, payload }: any) => {
        const tickFormatter = (value: string) => {
            const limit = 15;
            if (value.length < limit) return value;
            return `${value.substring(0, limit)}...`;
        };

        if (payload && payload.value) {
            return (
                <Text
                    fontSize={'.85rem'}
                    x={x}
                    y={y}
                    textAnchor="end"
                    verticalAnchor="middle"
                >
                    {tickFormatter(payload.value)}
                </Text>
            );
        }
        return null;
    };

    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={data}
                margin={{
                    top: 5,
                    right: 5,
                    left: 75,
                    bottom: 5,
                }}
                layout="vertical"
            >
                <CartesianGrid horizontal={false} />
                <XAxis type="number" allowDecimals={false} hide />
                <YAxis
                    width={70}
                    dataKey="category"
                    type="category"
                    tick={<CustomYAxisTick />}
                />
                <Tooltip />
                <Bar dataKey="Phones">
                    {data.map((entry, key) => (
                        <Cell
                            key={key}
                            fill={
                                entry.category === 'Unassigned'
                                    ? '#63c2d2'
                                    : '#3d9a8b'
                            }
                        ></Cell>
                    ))}
                    <LabelList dataKey="Phones" position="right" />
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
}

export default PhoneHorizontalBarGraph;
